export const buildSectionInstruction = (
  sectionName: string,
  wasEnabled: boolean,
  isEnabled: boolean
): string => {
  if (!wasEnabled && isEnabled)
    return `${sectionName} settings have been enabled. Update the prompt to reflect the changes.`
  if (wasEnabled && !isEnabled)
    return `${sectionName} settings have been disabled. Update the prompt to reflect the changes.`
  return `${sectionName} settings have been modified. Update the prompt to reflect the changes.`
}
